// extracted by mini-css-extract-plugin
module.exports = {"container":"betSuccessClient_container__3l7mw","results":"betSuccessClient_results__Z3oyf","noResults":"betSuccessClient_noResults__4171o"};